module.exports = __webpack_public_path__ + "img/microTyphoon_all.929ec02f.png";